import Box from "@mui/material/Box";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronLeft } from "@fortawesome/pro-regular-svg-icons";
import { useSidebarStore } from "../../store/sidebar/sidebarStore";
import { ANIMATION_DURATION } from "./constants";

export function SidebarToggler() {
  const { status, toggle } = useSidebarStore();
  const isCollapsed = status === "closed";

  return (
    <Box
      component="button"
      id="sidebar-button-collapse"
      onClick={toggle}
      sx={{
        width: "100%",
        padding: "8px 12px",
        margin: "8px 0",
        display: "flex",
        alignItems: "center",
        justifyContent: isCollapsed ? "center" : "flex-start",
        gap: "8px",
        border: "none",
        backgroundColor: "transparent",
        cursor: "pointer",
        borderRadius: "6px",
        color: "#1f1f1f",
        fontSize: "14px",
        fontWeight: 500,
        transition: `all ${ANIMATION_DURATION}ms cubic-bezier(0.4, 0, 0.2, 1)`,
        "&:hover": {
          backgroundColor: "#f9fafb",
        },
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          transform: isCollapsed ? "rotate(180deg)" : "rotate(0deg)",
          transition: `transform ${ANIMATION_DURATION}ms cubic-bezier(0.4, 0, 0.2, 1)`,
        }}
      >
        <FontAwesomeIcon icon={faChevronLeft} style={{ fontSize: "14px" }} />
      </Box>
      {!isCollapsed && (
        <Box component="span" sx={{ fontSize: "14px", fontWeight: 500 }}>
          Collapse
        </Box>
      )}
    </Box>
  );
}
